module.exports = __webpack_public_path__ + "static/media/AccountActivatedBigScreen.ba4fb6ae.svg";